import { render, staticRenderFns } from "./SocialFollow.vue?vue&type=template&id=1be0f3c8&scoped=true&"
import script from "./SocialFollow.vue?vue&type=script&lang=js&"
export * from "./SocialFollow.vue?vue&type=script&lang=js&"
import style0 from "./SocialFollow.vue?vue&type=style&index=0&id=1be0f3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0f3c8",
  null
  
)

/* custom blocks */
import block0 from "./SocialFollow.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports